<template>
  <div class="page__list">
    <search-bar
      @search="onSearch"
      name="mm_title,mm_mrname"
      placeholder="输入会议议题、会议地点进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/meeting_template/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.mm_code}}</p>
          <p class="list-item-muted"> {{item.mm_emnames}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.mm_title}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.mm_date}}</p>
         
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}条</label>
    </div>
    <add-button to="/oa/meeting_template_edit" icon="iconfont icon-add"/>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/meetingmodel/list",
      filters: [
        {
          type: "date",
          name: "createTime"
        },
      ]
    };
  },
  methods:{
    search(){
      this.onSearch()
    }
  }
};
</script>